import { render, staticRenderFns } from "./StudentInModel.vue?vue&type=template&id=7a24da6f&scoped=true&lang=pug&"
import script from "./StudentInModel.vue?vue&type=script&lang=ts&"
export * from "./StudentInModel.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInModel.vue?vue&type=style&index=0&id=7a24da6f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a24da6f",
  null
  
)

export default component.exports